import { Icon, IconName } from '@frontend/icons';
import { ListButton } from '../toolbox-atoms/list-button';
import { Warning } from './warning';

type Props = {
  children?: React.ReactNode;
  iconName?: IconName;
  onClick: () => void;
  warning?: string;
};

// TODO: Add tracking ids
export const SettingsPanelButton = ({ children, iconName, onClick, warning }: Props) => (
  <ListButton onClick={onClick}>
    {!!iconName && (
      <ListButton.Lead>
        <Icon name={iconName} css={{ maxWidth: 'initial' }} />
      </ListButton.Lead>
    )}

    <ListButton.Content>
      <ListButton.Content.Title isBold={false}>{children}</ListButton.Content.Title>
    </ListButton.Content>

    {!!warning && (
      <ListButton.Trail>
        <Warning>{warning}</Warning>
      </ListButton.Trail>
    )}
  </ListButton>
);
